
export default function IconWindows() {
  return (
    <svg width="104" height="103" viewBox="0 0 104 103" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.5 0H103.5V103H0.5V0Z" fill="#F3F3F3"/>
      <path d="M4.97826 4.47826H49.7609V49.2609H4.97826V4.47826Z" fill="#F35325"/>
      <path d="M54.2391 4.47826H99.0217V49.2609H54.2391V4.47826Z" fill="#81BC06"/>
      <path d="M4.97826 53.7391H49.7609V98.5217H4.97826V53.7391Z" fill="#05A6F0"/>
      <path d="M54.2391 53.7391H99.0217V98.5217H54.2391V53.7391Z" fill="#FFBA08"/>
    </svg>
  );
}
